module.exports = __webpack_public_path__ + "static/poster6-174f64293391e72b0480291ce3087bd2.png";